// extracted by mini-css-extract-plugin
export default {"overlay":"Dy-z","bodyOpen":"Ey-z","content":"Fy-z","header":"Gy-z","close":"Hy-z","closeNoHeading":"Iy-z"};